export default __webpack_public_path__ + "static/media/faucetIcon.7c43ff65.svg";